import { EVENT_MAP, sendLogToUWeb } from '@/plugins/umeng.ts'
import { store } from '@/pinia/store'
import { checkAppHandle, isApp } from '@/utils'
import { sendDataToApp } from '@/hooks/useBridge'
import { showToast } from '@/hooks/useVant'
import { currentDev } from '@/config/env'

export interface embeddingPointsTypes {
  eventId: string
  pageId: string
  pageName: string
  ext?: object | string
}

// 新版页面埋点
const doPageShowEvent = async (eventName: string, pageId: string, pageName: string, originId: string, comeType: number, ext?: any) => {
  // eventName: 事件名
  // pageName: 页面名称
  // pageId: 页面id
  // originId: 来源页id
  // comeType: 进入or离开 0：进入 1：离开
  const eventData = {
    pageId: pageId,
    pageName: pageName,
    origin: originId,
  }
  const currentTime = Date.now()
  if (comeType === 0) {
    eventData['startTime'] = currentTime.toString()
    eventData['endTime'] = '空'
    console.log('进入埋点', eventData)
  } else {
    eventData['startTime'] = '空'
    eventData['endTime'] = currentTime.toString()
    console.log('离开埋点', eventData)
  }
  const storeData = store()
  if (isApp() && (await checkAppHandle('pageExposure'))) {
    // 判断是否是app内嵌，则调用app桥接
    sendDataToApp('pageExposure', {
      ...eventData,
      eventId: eventName,
    })
  } else {
    const sendData = {
      ...eventData,
      user_id: storeData.appData.userId,
      platform: 'h5',
      ext: ext || '空',
    }
    /*if (currentDev !== 1) {
      const toastData = {
        ...sendData,
        eventId: eventName
      }
      if (comeType === 0) {
        setTimeout(() => {
          showToast('进入埋点数据：' + JSON.stringify(toastData), '', '', 5000)
        }, 5500)
      } else {
        showToast('离开埋点数据：' + JSON.stringify(toastData), '', '', 5000)
      }
    }*/
    sendLogToUWeb(
      EVENT_MAP.BUSINESS_EVENT,
      eventName,
      JSON.stringify({
        ...sendData,
      }),
    )
  }
}

// 埋点数据清洗
const cleanEmbeddingPoints = (routeItem: any) => {
  console.log('需要清洗的路由数据', routeItem)
  let embeddingPoints: embeddingPointsTypes = routeItem.meta.embeddingPoints || {}
  // 技师列表
  if (routeItem.name === 'technicianList') {
    if (routeItem.query.hasOwnProperty('defaultQuery')) {
      const defaultQuery = JSON.parse(routeItem.query.defaultQuery)
      const isHd = defaultQuery.userType === 8
      embeddingPoints = {
        eventId: isHd ? 'qjhdtech_list_event' : 'qjjgwytech_list_event',
        pageId: isHd ? 'hdtechlist' : 'jgwytechlist',
        pageName: isHd ? '汗滴技师列表页' : '往约技师列表页',
        ext: { userType: isHd ? 8 : 2 },
      }
    } else {
      embeddingPoints = {
        eventId: 'qjdhwytech_list_event',
        pageId: 'dhwytechlist',
        pageName: '往约技师列表页',
        ext: '空',
      }
    }
  } else {
    if (['technicianDetail', 'techProfile'].includes(routeItem.name)) {
      embeddingPoints['ext'] = { techid: routeItem.query['techId'] || '空' }
    } else if (routeItem.name === 'productDetail') {
      embeddingPoints['ext'] = { productid: routeItem.query['productId'] || '空' }
    } else if (routeItem.name === 'trendsDetail') {
      embeddingPoints['ext'] = { dynamicid: routeItem.query['id'] || '空' }
    } else if (routeItem.name === 'shareVideo') {
      embeddingPoints['ext'] = { videoid: routeItem.query['id'] || '空' }
    } else if (['payState', 'orderDetail', 'editOrder', 'applyRefund', 'refundDetail'].includes(routeItem.name)) {
      embeddingPoints['ext'] = { orderid: routeItem.query['orderId'] || '空' }
    } else if (routeItem.name === 'sharepay') {
      embeddingPoints['ext'] = { payShareCode: routeItem.query['payShareCode'] || '空' }
    } else if (routeItem.name === 'imMessage') {
      embeddingPoints = {
        eventId: routeItem.query['toAccount'] ? 'qjmessage_detail_event' : 'qjmessage_list_event',
        pageId: routeItem.query['toAccount'] ? 'messagedetail' : 'messagelist',
        pageName: routeItem.query['toAccount'] ? '消息详情页' : '消息列表页',
        ext: routeItem.query['toAccount'] ? { techid: routeItem.query['toAccount'] } : '空',
      }
    } else if (routeItem.name === 'bookingOrder') {
      embeddingPoints['ext'] = { request_id: routeItem.query['reqId'] || '空' }
    }
  }
  return embeddingPoints
}

// 特殊页面埋点
const specialPageEmbeddingPoints = (leaveEmbeddingPoints: any, enterEmbeddingPoints: any) => {
  const storeData = store()
  // 离开
  doPageShowEvent(
    leaveEmbeddingPoints.eventId,
    leaveEmbeddingPoints.pageId,
    leaveEmbeddingPoints.pageName,
    storeData.globalPrePageId || '空',
    1,
    leaveEmbeddingPoints?.ext,
  )
  // 进入
  doPageShowEvent(
    enterEmbeddingPoints.eventId,
    enterEmbeddingPoints.pageId,
    enterEmbeddingPoints.pageName,
    leaveEmbeddingPoints?.pageId || '空',
    0,
    enterEmbeddingPoints?.ext,
  )
  storeData.globalPrePageId = leaveEmbeddingPoints.pageId // 缓存上一页面id
}

// 弹窗埋点
const popupEmbeddingPoints = (leaveEmbeddingPoints: any, enterEmbeddingPoints: any, leavePageId: string, enterPageId: string) => {
  if (enterPageId !== '') {
    // 进入
    doPageShowEvent(enterEmbeddingPoints.eventId, enterEmbeddingPoints.pageId, enterEmbeddingPoints.pageName, enterPageId || '空', 0)
  } else {
    // 离开
    doPageShowEvent(leaveEmbeddingPoints.eventId, leaveEmbeddingPoints.pageId, leaveEmbeddingPoints.pageName, leavePageId || '空', 1)
  }
}

export { doPageShowEvent, cleanEmbeddingPoints, specialPageEmbeddingPoints, popupEmbeddingPoints }
